import React, { FC, useState } from 'react';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { IActionPages } from 'core/interface/actionPages';

import './Index.scss';

import { JobService } from 'services/jobs/job';

const Congratulation: FC<IActionPages> = ({
  t,
  onSubmit,
  isCompany,
  isRecruiter,
  me
}): JSX.Element => {
  const handleSubmit = (): void => {
    onSubmit();
  };

  const getAssessments = async (): Promise<void> => {
    if (!me?.id) return;
    try {
      const res = await JobService.postAssessments(me.id);
      if (res.test_logon_url) window.location.href = res.test_logon_url;
    } catch (error) {
      console.log(error);
    }
  };

  const handleTakeAssessment = async (): Promise<void> => {
    onSubmit(false);
    await getAssessments();
  };

  const handleGoToProfile = (): void => {
    onSubmit(true);
  };

  return (
    <div className="congrats">
      <Image name="congrats.svg" width={440} height={483} />
      <h1 className="congrats-title">{t('Congratulations!')}</h1>
      <p className="congrats-desc">
        {isCompany ? t('You’re about to embark on an exciting journey to find the perfect candidates for your team!') : t('You are about to embark on an exciting journey with our competency assessment. This is your chance to shine and demonstrate the unique skills and talents you possess.')}
      </p>
      {isCompany || isRecruiter ? (
        <Button
          onClick={handleSubmit}
          className="congrats-continue"
          title="Continue"
          t={t}
        />
      ) : (
        <div className="congrats-buttons-wrapper">
          <Button
            onClick={handleTakeAssessment}
            className="congrats-continue"
            title="Take assessment test"
            t={t}
          />
          <Button
            onClick={handleGoToProfile}
            className="congrats-profile"
            title="Take the test later"
            t={t}
          />
        </div>
      )}
    </div>
  );
};

export default Congratulation;
